import axios from "axios";
import { useState, useEffect } from "react";
import { ImageLoader } from "render-img";
import PlaceHolderImage from "./assets/placeholder.jpg";
import Loader from "./components/Loader";
import Car1 from "./assets/cars/car1.jpg";
import Car2 from "./assets/cars/car2.jpg";
import Car3 from "./assets/cars/car3.jpg";
import Car4 from "./assets/cars/car4.jpg";

function App() {
  const [photos, setPhotos] = useState([]);
  const instance = axios.create({
    // baseURL: "https://api.unsplash.com",
    baseURL: "https://rickandmortyapi.com",
  });
  const fetchImages = async () => {
    instance
      .get("/api/character")
      // .get("/photos?client_id=qG884q-kCB6Zw40KtQ0CZpEsNBTbb2MPhId56_hiB7o")
      .then(({ data }) => {
        setPhotos(() => data.results);
      });
  };
  useEffect(() => {
    fetchImages();
  }, []);

  return (
    <div className="App">
      <section className="container">
        <h3 className="py-3 text-3xl font-bold">Section 1</h3>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
      </section>
      <div className="min-h-screen"></div>
      <section className="container">
        <h3 className="py-3 text-3xl font-bold">Section 2</h3>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
      </section>
      <section className="container">
        <h3 className="py-3 text-3xl font-bold">Section 3</h3>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
      </section>
      <div className="min-h-screen"></div>
      <section className="container">
        <h3 className="py-3 text-3xl font-bold">Section 4</h3>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-4">
          <div className="overflow-hidden">
            <ImageLoader
              width={1937}
              height={2490}
              src={Car1}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={3456}
              height={5184}
              src={Car2}
              placeHolderSrc={PlaceHolderImage}
              isUseblur={true}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2724}
              height={3405}
              src={Car3}
              placeHolderSrc={PlaceHolderImage}
            />
          </div>
          <div className="overflow-hidden">
            <ImageLoader
              width={2178}
              height={3264}
              src={Car4}
              loader={
                <>
                  <Loader />
                </>
              }
            />
          </div>
        </div>
      </section>
    </div>
  );
}

export default App;
